<template>

  <div class="relative flex flex-col lg:flex-row lg:items-start">

    <component class="flex-auto p-4 sm:p-8" v-if="component" :is="component" :data="data" @applyAction="applyAction" />

    <div v-if="showCart" class="w-full lg:w-500px lg:min-w-500px lg:max-w-500px">

      <VaCart title="My Project" :data="cart" :shadow="false" class="sm:mt-10 sm:mx-10 sm:mb-16 sm:shadow-lg">

        <div v-if="cartHasSections" slot="footer">

          <div class="text-center p-2">
            <!-- <h4 class="basket-heading-section mb-8">Add an Area</h4> -->
            <AddAreaButtons />
          </div>

          <div class="divider-border"></div>

          <div class="text-center">
            <EmailSummaryButton />
          </div>

          <div class="divider-border"></div>

          <div class="text-center">
            <NewProjectButton />
          </div>

        </div>

      </VaCart>

    </div>

  </div>

</template>

<script>

import VaCart from '@/components/VaCart.vue'

import AddAreaButtons from '@/components/AddAreaButtons.vue'

import NewProjectButton from '@/components/NewProjectButton.vue'

import EmailSummaryButton from '@/components/EmailSummaryButton.vue'

import { mapState, mapActions } from 'vuex'

export default {

  name: 'VaPlayer',

  components: {

    VaCart,

    AddAreaButtons,

    NewProjectButton,

    EmailSummaryButton

  },

  data () {

    return {

      component: null

    }

  },

  computed: {

    stateid: {
      get () { return parseInt(this.$store.state.stateid, 10); },
      set (stateid) { this.$store.commit('setStateid', parseInt(stateid, 10)); }
    },

    ...mapState(['vastate', 'data', 'cart']),

    showCart () {

      let vastate = this.vastate || 'blank';

      let dontShowIf = ['blank', 'summary'];

      return dontShowIf.indexOf(vastate) === -1;

    },

    cartHasSections () {

      return this.cart && this.cart.sections && this.cart.sections.length;

    },

    loader () {

      let vastate = this.vastate || null;

      let map = {
        'step'       : 'VaStep',
        'decision'   : 'VaDecision',
        'record'     : 'VaRecord',
        'records'    : 'VaRecords',
        'summary'    : 'VaSummary',
        'whats_next' : 'VaWhatsNext'
      };

      let cmp = map[vastate] || 'Va404';

      return () => import(`@/components/${cmp}.vue`);
    }
  },

  beforeRouteEnter (to, from, next) {

    let stateid = to.params.stateid || 0;

    next(_this => { _this.stateid = stateid; });
  },

  beforeRouteUpdate (to, from, next) {

    this.stateid = to.params.stateid || 0;

    next();
  },

  watch: {

    '$route' () { this.stateid = this.$route.params.stateid || 0; },

    stateid (newStateid) {
      this.loadState(newStateid);
      this.loadCart(newStateid);
    },

    data: function(data) {
      data['stateid'] = parseInt(this.stateid, 10) || 0;
      this.setData(this.stateid, data);
    }
  },

  methods: {

    ...mapActions(['loadState', 'applyAction', 'loadCart']),

    setData (stateid, data) {

      let title = data.title ? `| ${data.title}` : '';

      document.title = `Polyflor ${title}`;

      this.loader()

        .then(() => {
          this.component = () => this.loader();
        })

        .catch(() => {
          this.component = () => import('@/components/Va404.vue');
        });
    }
  }
}
</script>
